export default __webpack_public_path__ + "static/media/mortgage-process.15057c60.webp";